import React, { Component, Fragment } from "react";

import classNames from "classnames";
import { generateId } from "../../shared/utils";
import i18n from "../../shared/i18n/i18n";

import FieldText from "../../SharedComponent/FieldText/FieldText";
import FieldSetStudentNames from "../../SharedComponent/FieldSetNames/FieldSetNames";
import FieldRadio from "../../SharedComponent/FieldRadio/FieldRadio";
import FieldSetIdentityCard from "../../SharedComponent/FieldSetIdentityCard/FieldSetIdentityCard";
import FieldSetLocation from "../../SharedComponent/FieldSetLocation/FieldSetLocation";
import FieldCheck from "../../SharedComponent/FieldCheck/FieldCheck";
import FieldMultilingualSelect from "../../SharedComponent/FieldMultilingualSelect/FieldMultilingualSelect";
import FieldSelect from "../../SharedComponent/FieldSelect/FieldSelect";
import FieldSetNames from "../../SharedComponent/FieldSetNames/FieldSetNames";
import FieldCheckAndUpload from "../../SharedComponent/FieldCheckAndUpload/FieldCheckAndUpload";

export default class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: "student", // 'studentAgent'
      errorTabs: [],
    };

    this.ui = {
      studentKnowFrom: React.createRef(),
      studentLogin: React.createRef(),
      studentPassword: React.createRef(),
      studentEmail: React.createRef(),
      studentPhone: React.createRef(),
      studentNames: React.createRef(),
      studentTypeIdCard: React.createRef(),
      studentIdCard: React.createRef(),
      studentLocation: React.createRef(),
      // studentPostalCode: React.createRef(),
      // studentAddress: React.createRef(),
      // studentSchoolLocationType: React.createRef(),
      // studentSchoolLocation: React.createRef(),
      // studentSchoolName: React.createRef(),
      // studentSchoolStartYear: React.createRef(),
      studentClassId: React.createRef(),
      studentAgentEmail: React.createRef(),
      studentAgentPhone: React.createRef(),
      studentAgentNames: React.createRef(),
      studentAgentIdCard: React.createRef(),
      studentAgentLocation: React.createRef(),
      studentAgentPostalCode: React.createRef(),
      studentAgentAddress: React.createRef(),
      statusLargeFamily: React.createRef(),
      statusPoorFamily: React.createRef(),
      statusSingleParentFamily: React.createRef(),
      statusDisabilityMember: React.createRef(),
      statusMiddleTownInhabitant: React.createRef(),
      statusSmallTownInhabitant: React.createRef(),
      statusCountrysideInhabitant: React.createRef(),
      statusRefugeeFamily: React.createRef(),
    };

    this.getData = this.getData.bind(this);
    this.setData = this.setData.bind(this);
    this.check = this.check.bind(this);
    this.showTab = this.showTab.bind(this);

    this.updateClassListForCountry = this.updateClassListForCountry.bind(this);
    this.updateSchoolListForCity = this.updateSchoolListForCity.bind(this);
  }

  getData() {
    let school_name = "";
    let school_item = null;

    let statusLargeFamily = "";
    let fileLargeFamily = { hasFile: false, file: null };
    if (this.ui.statusLargeFamily.current.getValue()) {
      statusLargeFamily = this.ui.statusLargeFamily.current.getEnabled()
        ? "YES"
        : "APPROVED";
      fileLargeFamily = this.ui.statusLargeFamily.current.getFile();
    } else {
      statusLargeFamily = this.ui.statusLargeFamily.current.getEnabled()
        ? "NO"
        : "REJECTED";
    }

    let statusPoorFamily = "";
    let filePoorFamily = { hasFile: false, file: null };
    if (this.ui.statusPoorFamily.current.getValue()) {
      statusPoorFamily = this.ui.statusPoorFamily.current.getEnabled()
        ? "YES"
        : "APPROVED";
      filePoorFamily = this.ui.statusPoorFamily.current.getFile();
    } else {
      statusPoorFamily = this.ui.statusPoorFamily.current.getEnabled()
        ? "NO"
        : "REJECTED";
    }

    let statusSingleParentFamily = "";
    let fileSingleParentFamily = { hasFile: false, file: null };
    if (this.ui.statusSingleParentFamily.current.getValue()) {
      statusSingleParentFamily =
        this.ui.statusSingleParentFamily.current.getEnabled()
          ? "YES"
          : "APPROVED";
      fileSingleParentFamily =
        this.ui.statusSingleParentFamily.current.getFile();
    } else {
      statusSingleParentFamily =
        this.ui.statusSingleParentFamily.current.getEnabled()
          ? "NO"
          : "REJECTED";
    }

    let statusDisabilityMember = "";
    let fileDisabilityMember = { hasFile: false, file: null };
    if (this.ui.statusDisabilityMember.current.getValue()) {
      statusDisabilityMember =
        this.ui.statusDisabilityMember.current.getEnabled()
          ? "YES"
          : "APPROVED";
      fileDisabilityMember = this.ui.statusDisabilityMember.current.getFile();
    } else {
      statusDisabilityMember =
        this.ui.statusDisabilityMember.current.getEnabled() ? "NO" : "REJECTED";
    }

    let statusMiddleTownInhabitant = "";
    if (this.ui.statusMiddleTownInhabitant.current.getValue()) {
      statusMiddleTownInhabitant =
        this.ui.statusMiddleTownInhabitant.current.getEnabled()
          ? "YES"
          : "APPROVED";
    } else {
      statusMiddleTownInhabitant =
        this.ui.statusMiddleTownInhabitant.current.getEnabled()
          ? "NO"
          : "REJECTED";
    }

    let statusSmallTownInhabitant = "";
    if (this.ui.statusSmallTownInhabitant.current.getValue()) {
      statusSmallTownInhabitant =
        this.ui.statusSmallTownInhabitant.current.getEnabled()
          ? "YES"
          : "APPROVED";
    } else {
      statusSmallTownInhabitant =
        this.ui.statusSmallTownInhabitant.current.getEnabled()
          ? "NO"
          : "REJECTED";
    }

    let statusCountrysideInhabitant = "";
    if (this.ui.statusCountrysideInhabitant.current.getValue()) {
      statusCountrysideInhabitant =
        this.ui.statusCountrysideInhabitant.current.getEnabled()
          ? "YES"
          : "APPROVED";
    } else {
      statusCountrysideInhabitant =
        this.ui.statusCountrysideInhabitant.current.getEnabled()
          ? "NO"
          : "REJECTED";
    }

    let statusRefugeeFamily = "";
    let fileRefugeeFamily = { hasFile: false, file: null };
    if (this.ui.statusRefugeeFamily.current.getValue()) {
      statusRefugeeFamily = this.ui.statusRefugeeFamily.current.getEnabled()
        ? "YES"
        : "APPROVED";
      fileRefugeeFamily = this.ui.statusRefugeeFamily.current.getFile();
    } else {
      statusRefugeeFamily = this.ui.statusRefugeeFamily.current.getEnabled()
        ? "NO"
        : "REJECTED";
    }

    let data = {
      student: {
        login: this.ui.studentLogin.current.getValue(),
        password: this.ui.studentPassword.current.getValue(),
        email: this.ui.studentEmail.current.getValue(),
        knowFrom: parseInt(this.ui.studentKnowFrom.current.getValue()),
        phone: this.ui.studentPhone.current.getValue(),
        names: this.ui.studentNames.current.getValue(),
        typeIdCard: this.ui.studentTypeIdCard.current.getValue(),
        idCard: this.ui.studentIdCard.current.getValue(),
        location: this.ui.studentLocation.current.getValue(),
        postalCode: "",
        address: "",
        uiLanguage: this.props.setting.lang,
        utcShift: 180,
        school: {
          // locationType: this.ui.studentSchoolLocationType.current.getValue(),
          // location: this.ui.studentSchoolLocation.current.getValue(),
          locationType: true,
          location: this.ui.studentLocation.current.getValue(),
          name: school_name,
          id: school_item ? school_item.id : 0,
          startYear: 0,
          classId: parseInt(this.ui.studentClassId.current.getValue()) || 0, // TODO:
        },
      },
      studentAgent: {
        email: this.ui.studentAgentEmail.current.getValue(),
        phone: this.ui.studentAgentPhone.current.getValue(),
        names: this.ui.studentAgentNames.current.getValue(),
        idCard: this.ui.studentAgentIdCard.current.getValue(),
        location: this.ui.studentAgentLocation.current.getValue(),
        postalCode: this.ui.studentAgentPostalCode.current.getValue(),
        address: this.ui.studentAgentAddress.current.getValue(),
      },
      social: {
        statusLargeFamily,
        fileLargeFamily,
        statusPoorFamily,
        filePoorFamily,
        statusSingleParentFamily,
        fileSingleParentFamily,
        statusDisabilityMember,
        fileDisabilityMember,
        statusMiddleTownInhabitant,
        statusSmallTownInhabitant,
        statusCountrysideInhabitant,
        statusRefugeeFamily,
        fileRefugeeFamily,
      },
    };
    return data;
  }

  setData(data) {
    this.ui.studentLogin.current.setValue(data.student.login);
    this.ui.studentPassword.current.setValue("");
    this.ui.studentEmail.current.setValue(data.student.email);
    this.ui.studentKnowFrom.current.setValue(data.student.knowFrom);
    this.ui.studentPhone.current.setValue(data.student.phone);
    this.ui.studentNames.current.setValue(data.student.names);
    this.ui.studentTypeIdCard.current.setValue(data.student.typeIdCard);
    this.ui.studentIdCard.current.setValue(data.student.idCard);
    this.ui.studentLocation.current.setValue(data.student.location);
    // this.ui.studentPostalCode.current.setValue(data.student.postalCode);
    // this.ui.studentAddress.current.setValue(data.student.address);
    // this.ui.studentSchoolLocationType.current.setValue(data.student.school.locationType);
    // this.ui.studentSchoolLocation.current.setValue(data.student.school.location);
    // this.ui.studentSchoolName.current.setValue(data.student.school.name);
    // this.ui.studentSchoolStartYear.current.setValue(data.student.school.startYear);
    this.ui.studentClassId.current.setValue(data.student.school.classId);
    this.ui.studentAgentEmail.current.setValue(data.studentAgent.email);
    this.ui.studentAgentPhone.current.setValue(data.studentAgent.phone);
    this.ui.studentAgentNames.current.setValue(data.studentAgent.names);
    this.ui.studentAgentIdCard.current.setValue(data.studentAgent.idCard);
    this.ui.studentAgentLocation.current.setValue(data.studentAgent.location);
    this.ui.studentAgentPostalCode.current.setValue(
      data.studentAgent.postalCode
    );
    this.ui.studentAgentAddress.current.setValue(data.studentAgent.address);

    this.ui.statusLargeFamily.current.setValue(
      data.social.statusLargeFamily === "YES" ||
        data.social.statusLargeFamily === "APPROVED"
    );
    this.ui.statusLargeFamily.current.enabled(
      data.social.statusLargeFamily === "YES" ||
        data.social.statusLargeFamily === "NO"
    );
    this.ui.statusLargeFamily.current.setHasFile(
      data.social.hasFileLargeFamily
    );

    this.ui.statusPoorFamily.current.setValue(
      data.social.statusPoorFamily === "YES" ||
        data.social.statusPoorFamily === "APPROVED"
    );
    this.ui.statusPoorFamily.current.enabled(
      data.social.statusPoorFamily === "YES" ||
        data.social.statusPoorFamily === "NO"
    );
    this.ui.statusPoorFamily.current.setHasFile(data.social.hasFilePoorFamily);

    this.ui.statusSingleParentFamily.current.setValue(
      data.social.statusSingleParentFamily === "YES" ||
        data.social.statusSingleParentFamily === "APPROVED"
    );
    this.ui.statusSingleParentFamily.current.enabled(
      data.social.statusSingleParentFamily === "YES" ||
        data.social.statusSingleParentFamily === "NO"
    );
    this.ui.statusSingleParentFamily.current.setHasFile(
      data.social.hasFileSingleParentFamily
    );

    this.ui.statusDisabilityMember.current.setValue(
      data.social.statusDisabilityMember === "YES" ||
        data.social.statusDisabilityMember === "APPROVED"
    );
    this.ui.statusDisabilityMember.current.enabled(
      data.social.statusDisabilityMember === "YES" ||
        data.social.statusDisabilityMember === "NO"
    );
    this.ui.statusDisabilityMember.current.setHasFile(
      data.social.hasFileDisabilityMember
    );

    this.ui.statusMiddleTownInhabitant.current.setValue(
      data.social.statusMiddleTownInhabitant === "YES" ||
        data.social.statusMiddleTownInhabitant === "APPROVED"
    );
    this.ui.statusMiddleTownInhabitant.current.enabled(
      data.social.statusMiddleTownInhabitant === "YES" ||
        data.social.statusMiddleTownInhabitant === "NO"
    );

    this.ui.statusSmallTownInhabitant.current.setValue(
      data.social.statusSmallTownInhabitant === "YES" ||
        data.social.statusSmallTownInhabitant === "APPROVED"
    );
    this.ui.statusSmallTownInhabitant.current.enabled(
      data.social.statusSmallTownInhabitant === "YES" ||
        data.social.statusSmallTownInhabitant === "NO"
    );

    this.ui.statusCountrysideInhabitant.current.setValue(
      data.social.statusCountrysideInhabitant === "YES" ||
        data.social.statusCountrysideInhabitant === "APPROVED"
    );
    this.ui.statusCountrysideInhabitant.current.enabled(
      data.social.statusCountrysideInhabitant === "YES" ||
        data.social.statusCountrysideInhabitant === "NO"
    );

    this.ui.statusRefugeeFamily.current.setValue(
      data.social.statusRefugeeFamily === "YES" ||
        data.social.statusRefugeeFamily === "APPROVED"
    );
    this.ui.statusRefugeeFamily.current.enabled(
      data.social.statusRefugeeFamily === "YES" ||
        data.social.statusRefugeeFamily === "NO"
    );
    this.ui.statusRefugeeFamily.current.setHasFile(
      data.social.hasFileRefugeeFamily
    );
  }

  check() {
    let studentLogin = this.ui.studentLogin.current;
    let studentPassword = this.ui.studentPassword.current;
    let studentEmail = this.ui.studentEmail.current;
    let studentKnowFrom = this.ui.studentKnowFrom.current;
    let studentPhone = this.ui.studentPhone.current;
    let studentLocation = this.ui.studentLocation.current;
    // let studentPostalCode = this.ui.studentPostalCode.current;
    // let studentAddress = this.ui.studentAddress.current;
    // let studentSchoolLocation = this.ui.studentSchoolLocation.current;
    // let studentSchoolName = this.ui.studentSchoolName.current;
    // let studentSchoolStartYear = this.ui.studentSchoolStartYear.current;
    let studentNames = this.ui.studentNames.current;
    let studentClassId = this.ui.studentClassId.current;

    studentLogin.setError("");
    studentPassword.setError("");
    studentEmail.setError("");
    studentKnowFrom.setError("");
    studentPhone.setError("");
    studentLocation.setError("");
    // studentPostalCode.setError('');
    // studentAddress.setError('');
    // studentSchoolLocation.setError('');
    // studentSchoolName.setError('');
    // studentSchoolStartYear.setError('');
    studentNames.setError("");
    studentClassId.setError("");

    let errorTabs = new Set();

    if (studentLogin.getValue().length === 0) {
      errorTabs.add("student");
      studentLogin.setError("NOTE_ENTER_DATA");
    } else if (/\s/g.test(studentLogin.getValue())) {
      errorTabs.add("student");
      studentLogin.setError("NOTE_DATA_WITHOUT_SPACE");
    }
    if (studentPassword.getValue().length === 0) {
      errorTabs.add("student");
      studentPassword.setError("NOTE_ENTER_DATA");
    } else if (/\s/g.test(studentPassword.getValue())) {
      errorTabs.add("student");
      studentPassword.setError("NOTE_DATA_WITHOUT_SPACE");
    }
    if (studentEmail.getValue().length === 0) {
      errorTabs.add("student");
      studentEmail.setError("NOTE_ENTER_DATA");
    } else {
      var validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (!studentEmail.getValue().match(validRegex)) {
        errorTabs.add("student");
        studentEmail.setError("NOTE_INVALID_EMAIL");
      }
    }
    if (studentKnowFrom.getValue() === -1) {
      errorTabs.add("student");
      studentKnowFrom.setError("NOTE_ENTER_DATA");
    }
    if (studentPhone.getValue().length === 0) {
      errorTabs.add("student");
      studentPhone.setError("NOTE_ENTER_DATA");
    }
    // if (studentPostalCode.getValue().length === 0) {
    //     errorTabs.add('student');
    //     studentPostalCode.setError('NOTE_ENTER_DATA');
    // }
    // if (studentAddress.getValue().length === 0) {
    //     errorTabs.add('student');
    //     studentAddress.setError('NOTE_ENTER_DATA');
    // }

    let locationValue = studentLocation.getValue();
    let errorFields = [];

    if (locationValue.city.id === 0 && locationValue.city.name.length === 0)
      errorFields.push("city");
    if (locationValue.region.id === 0) errorFields.push("region");
    if (locationValue.country.id === 0) errorFields.push("country");
    if (errorFields.length !== 0) {
      errorTabs.add("student");
      studentLocation.setError("NOTE_ENTER_DATA", errorFields);
    }

    // locationValue = studentSchoolLocation.getValue();
    // errorFields = [];
    // // if (locationValue.city.id === 0 && locationValue.city.name.length === 0) errorFields.push('city');
    // // if (locationValue.region.id === 0) errorFields.push('region');
    // if (locationValue.country.id === 0) errorFields.push('country');
    // if (errorFields.length !== 0) {
    //     errorTabs.add('student');
    //     studentSchoolLocation.setError('NOTE_ENTER_DATA', errorFields);
    // }

    let namesValue = studentNames.getValue();
    errorFields = [];

    if (namesValue.firstName.length === 0) errorFields.push("firstName");
    if (namesValue.lastName.length === 0) errorFields.push("lastName");
    //        if (namesValue.middleName.length === 0) errorFields.push('middleName');
    if (namesValue.birthdate.length === 0) errorFields.push("birthdate");
    if (errorFields.length !== 0) {
      errorTabs.add("student");
      studentNames.setError("NOTE_ENTER_DATA", errorFields);
    }

    // if (studentSchoolName.getValue().length === 0) {
    //     errorTabs.add('student');
    //     studentSchoolName.setError('NOTE_ENTER_DATA');
    // }
    // if (studentSchoolStartYear.getValue().length !== 4) {
    //     errorTabs.add('student');
    //     studentSchoolStartYear.setError('NOTE_ENTER_DATA');
    // }
    if (studentClassId.getValue() === -1) {
      errorTabs.add("student");
      studentClassId.setError("NOTE_ENTER_DATA");
    }

    this.setState({ errorTabs: [...errorTabs] });

    return errorTabs.size === 0;
  }

  showTab(tab) {
    this.setState({ tab });
  }

  updateClassListForCountry(countryId) {
    this.props.message.current.hide();
    this.ui.studentClassId.current.showSpinner(true);
    this.ui.studentClassId.current.setValue(-1);
    this.ui.studentClassId.current.enabled(false);

    fetch("api/request.php", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        action: "getClassListForCountry",
        payload: {
          id: parseInt(countryId),
        },
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.type !== 0) {
          this.ui.studentClassId.current.showSpinner(false);
          this.ui.studentClassId.current.enabled(true);
          this.props.message.current.setMessage(json.code, "danger", false);
          return;
        }

        this.ui.studentClassId.current.setData(json.data);
        this.ui.studentClassId.current.showSpinner(false);
        this.ui.studentClassId.current.enabled(true);
      })
      .catch(error => {
        debugger;
        this.ui.studentClassId.current.showSpinner(false);
        this.ui.studentClassId.current.enabled(true);
        this.props.message.current.setMessage("ERR_UNKNOWN", "danger", false);
      });
  }

  updateSchoolListForCity(cityId) {
    return;
    this.props.message.current.hide();
    if (cityId === 0) {
      this.ui.studentSchoolName.current.setData([]);
      return;
    }
    this.ui.studentSchoolName.current.showSpinner(true);
    this.ui.studentSchoolName.current.enabled(false);

    fetch("api/request.php", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        action: "getSchoolListForCity",
        payload: {
          id: parseInt(cityId),
        },
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.type !== 0) {
          this.ui.studentSchoolName.current.showSpinner(false);
          this.ui.studentSchoolName.current.enabled(true);
          this.props.message.current.setMessage(json.code, "danger", false);
          return;
        }

        this.ui.studentSchoolName.current.setData(json.data);
        this.ui.studentSchoolName.current.showSpinner(false);
        this.ui.studentSchoolName.current.enabled(true);
      })
      .catch(error => {
        debugger;
        this.ui.studentSchoolName.current.showSpinner(false);
        this.ui.studentSchoolName.current.enabled(true);
        this.props.message.current.setMessage("ERR_UNKNOWN", "danger", false);
      });
  }

  render() {
    console.log(this.props.setting.data);
    return (
      <Fragment>
        <div className="tab-menu tab-menu-left m01rem hidden">
          <div
            className={classNames(
              "tab-item",
              this.state.tab === "student" ? "active" : "",
              this.state.errorTabs.includes("student") ? "error" : ""
            )}
            onClick={e => this.showTab("student")}
          >
            {i18n("STUDENT", this.props.setting.lang)}
          </div>
          <div
            className={classNames(
              "tab-item",
              this.state.tab === "studentAgent" ? "active" : "",
              this.state.errorTabs.includes("studentAgent") ? "error" : ""
            )}
            onClick={e => this.showTab("studentAgent")}
          >
            {i18n("STUDENT_PARENT", this.props.setting.lang)}
          </div>
        </div>
        <div className="fb-col m1rem p05rem">
          {/*<div><span className="text-danger">*</span> - {i18n("NOTE_REQUIRED_FIELDS", this.props.setting.lang)}</div>*/}
          {/*<div><span className="text-primary">**</span> - {i18n("NOTE_REQUIRED_PARTICIPANT_FIELDS", this.props.setting.lang)}</div>*/}
        </div>
        <div className="m01rem">
          <div className={this.state.tab === "student" ? "" : "hidden"}>
            <div className="fb-row">
              <FieldMultilingualSelect
                ref={this.ui.studentKnowFrom}
                setting={this.props.setting}
                option={{
                  label: "NOTE_KNOW_FROM",
                  preData: [
                    { id: -1, name: "NOTE_CHOOSE_KNOW_FROM", disabled: true },
                  ],
                  sort: true,
                  data: this.props.setting.data.knowFrom.data,
                }}
              />
            </div>
            <div className="fb-row">
              <FieldText
                ref={this.ui.studentLogin}
                setting={this.props.setting}
                option={{
                  label: "LOGIN",
                  type: "text",
                  value: "",
                  size: 20,
                  onChange: function (value) {
                    return value.length <= 100;
                  },
                  // mark: {symbol: '*', className: 'text-danger'},
                }}
              />
              <FieldText
                ref={this.ui.studentPassword}
                setting={this.props.setting}
                option={{
                  label: "PASSWORD",
                  type: "text",
                  value: "",
                  size: 20,
                  // mark: {symbol: '*', className: 'text-danger'},
                }}
              />
              <FieldText
                ref={this.ui.studentEmail}
                setting={this.props.setting}
                option={{
                  label: "EMAIL",
                  type: "text",
                  value: "",
                  size: 50,
                  onChange: function (value) {
                    return value.length <= 100;
                  },
                  // mark: {symbol: '*', className: 'text-danger'},
                }}
              />
              <FieldText
                ref={this.ui.studentPhone}
                setting={this.props.setting}
                option={{
                  label: "PHONE",
                  type: "text",
                  value: "",
                  size: 40,
                  onChange: function (value) {
                    return value.length <= 50;
                  },
                  // mark: {symbol: '*', className: 'text-danger'},
                }}
              />
            </div>
            <FieldSetStudentNames
              ref={this.ui.studentNames}
              setting={this.props.setting}
              spinner={this.props.spinner}
              message={this.props.message}
            />
            <fieldset className="hidden">
              <legend>{i18n("SOCIAL_STATUS", this.props.setting.lang)}</legend>
              <div className="fb-wrap-row">
                <FieldCheckAndUpload
                  ref={this.ui.statusLargeFamily}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_LARGE_FAMILY",
                  }}
                />
                <FieldCheckAndUpload
                  ref={this.ui.statusPoorFamily}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_POOR_FAMILY",
                  }}
                />
                <FieldCheckAndUpload
                  ref={this.ui.statusSingleParentFamily}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_SINGLE_PARENT_FAMILY",
                  }}
                />
                <FieldCheckAndUpload
                  ref={this.ui.statusDisabilityMember}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_DISABILITY_MEMBER",
                  }}
                />
                <FieldCheck
                  ref={this.ui.statusMiddleTownInhabitant}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_MIDDLE_TOWN_INHABITANT",
                  }}
                />
                <FieldCheck
                  ref={this.ui.statusSmallTownInhabitant}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_SMALL_TOWN_INHABITANT",
                  }}
                />
                <FieldCheck
                  ref={this.ui.statusCountrysideInhabitant}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_COUNTRYSIDE_INHABITANT",
                  }}
                />
                <FieldCheckAndUpload
                  ref={this.ui.statusRefugeeFamily}
                  setting={this.props.setting}
                  option={{
                    label: "STATUS_REFUGEE_FAMILY",
                  }}
                />
              </div>
            </fieldset>
            <fieldset className="hidden">
              <legend>{i18n("IDENTITY_CARD", this.props.setting.lang)}</legend>
              <FieldRadio
                ref={this.ui.studentTypeIdCard}
                setting={this.props.setting}
                option={{
                  value: "BIRTH",
                  radio: [
                    {
                      id: 1,
                      label: "BIRTH_CERTIFICATE",
                      value: "BIRTH",
                      enabled: true,
                    },
                    {
                      id: 2,
                      label: "PASSPORT",
                      value: "PASS",
                      enabled: true,
                    },
                  ],
                }}
              />
              <FieldSetIdentityCard
                ref={this.ui.studentIdCard}
                setting={this.props.setting}
                spinner={this.props.spinner}
                message={this.props.message}
              />
            </fieldset>
            <fieldset>
              <legend>
                {i18n("PLACE_OF_LIVING", this.props.setting.lang)}
              </legend>
              <FieldSetLocation
                ref={this.ui.studentLocation}
                setting={this.props.setting}
                spinner={this.props.spinner}
                message={this.props.message}
                option={{
                  onCountryChanged: function (countryId) {
                    // if (this.ui.studentSchoolLocationType.current.getValue()) {
                    //     this.ui.studentSchoolLocationType.current.setValue(false);
                    // }
                    this.updateClassListForCountry(countryId);
                  }.bind(this),
                  onRegionChanged: function (regionId) {
                    // if (this.ui.studentSchoolLocationType.current.getValue()) {
                    //     this.ui.studentSchoolLocationType.current.setValue(false);
                    // }
                  }.bind(this),
                  onCityChanged: function (cityId, cityName) {
                    // if (this.ui.studentSchoolLocationType.current.getValue()) {
                    //     this.ui.studentSchoolLocationType.current.setValue(false);
                    // }
                  }.bind(this),
                }}
              />
              {/*<div className="fb-row">*/}
              {/*    <FieldText ref={this.ui.studentPostalCode} setting={this.props.setting} option={{*/}
              {/*        label: "POSTAL_CODE",*/}
              {/*        type: "text",*/}
              {/*        value: "",*/}
              {/*        size: 20,*/}
              {/*        onChange: function (value) {*/}
              {/*            return value.length <= 10;*/}
              {/*        },*/}
              {/*    }}/>*/}
              {/*    <FieldText ref={this.ui.studentAddress} setting={this.props.setting} option={{*/}
              {/*        label: "ADDRESS",*/}
              {/*        type: "text",*/}
              {/*        value: "",*/}
              {/*        className: "fb-1",*/}
              {/*    }}/>*/}
              {/*</div>*/}
            </fieldset>
            <fieldset>
              <legend>
                {i18n("EDUCATIONAL_SCHOOL", this.props.setting.lang)}
              </legend>
              {/* <FieldCheck ref={this.ui.studentSchoolLocationType} setting={this.props.setting} option={{
                                label: "NOTE_EDUCATIONAL_SCHOOL_LOCATION_TYPE",
                                onChange: function (value) {
                                    if (value) {
                                        this.ui.studentSchoolLocation.current.enabled(false);
                                        let locationValue = this.ui.studentLocation.current.getFullValue();
                                        this.ui.studentSchoolLocation.current.setValue(locationValue);
                                        this.updateClassListForCountry(locationValue.country.id);
                                        this.updateSchoolListForCity(locationValue.city.id, locationValue.city.name);
                                    } else {
                                        this.ui.studentSchoolLocation.current.enabled(true);
                                    }
                                    return true;
                                }.bind(this),
                            }} />
                            <FieldSetLocation
                                ref={this.ui.studentSchoolLocation}
                                setting={this.props.setting}
                                spinner={this.props.spinner}
                                message={this.props.message}
                                noRegionAndCity={true}
                                option={{
                                    onCountryChanged: function (countryId) {
                                        this.updateClassListForCountry(countryId);
                                    }.bind(this),
                                    // onRegionChanged: function (regionId) {
                                    //     console.log('onRegionChanged', regionId);
                                    // }.bind(this),
                                    onCityChanged: function (cityId, cityName) {
                                        this.updateSchoolListForCity(cityId);
                                    }.bind(this),
                                }}
                            /> */}
              {/*<div className="fb-row">*/}
              {/*    <FieldText ref={this.ui.studentSchoolName} setting={this.props.setting} option={{*/}
              {/*        label: "SCHOOL_NAME",*/}
              {/*        type: "text",*/}
              {/*        hasSpinner: true,*/}
              {/*        className: "fb-gr-1",*/}
              {/*        onChange: function (value) {*/}
              {/*            return value.length <= 2000;*/}
              {/*        },*/}

              {/*    }}/>*/}
              {/*</div>*/}
              <div className="fb-row">
                {/*<FieldText ref={this.ui.studentSchoolStartYear} setting={this.props.setting} option={{*/}
                {/*    label: "START_YEAR",*/}
                {/*    type: "text",*/}
                {/*    size: 4,*/}
                {/*    onChange: function (value) {*/}
                {/*        return /^\d{0,4}$/.test(value); // only 4 digits*/}
                {/*    },*/}
                {/*}}/>*/}
                <FieldSelect
                  ref={this.ui.studentClassId}
                  setting={this.props.setting}
                  option={{
                    // label: "CURRENT_CLASS",
                    labelFunc: function (lang) {
                      return (
                        <span>
                          {i18n("CURRENT_CLASS_1", lang)}&nbsp;
                          <strong>
                            {
                              this.props.setting.data.settings.data
                                .schoolYearName
                            }
                          </strong>
                          &nbsp;{i18n("CURRENT_CLASS_2", lang)}
                        </span>
                      );
                    }.bind(this),
                    preData: [
                      { id: -1, name: "NOTE_CHOOSE_CLASS", disabled: true },
                      { id: 0, name: "NOTE_FINISHED_SCHOOL" },
                    ],
                    hasSpinner: true,
                  }}
                />
              </div>
            </fieldset>
          </div>
          <div className={this.state.tab === "studentAgent" ? "" : "hidden"}>
            <div className="fb-row">
              <FieldText
                ref={this.ui.studentAgentEmail}
                setting={this.props.setting}
                option={{
                  label: "EMAIL",
                  type: "text",
                  value: "",
                  size: 50,
                  onChange: function (value) {
                    return value.length <= 100;
                  },
                }}
              />
              <FieldText
                ref={this.ui.studentAgentPhone}
                setting={this.props.setting}
                option={{
                  label: "PHONE",
                  type: "text",
                  value: "",
                  size: 50,
                  onChange: function (value) {
                    return value.length <= 50;
                  },
                }}
              />
            </div>
            <FieldSetNames
              ref={this.ui.studentAgentNames}
              setting={this.props.setting}
              spinner={this.props.spinner}
              message={this.props.message}
            />
            <fieldset>
              <legend>{i18n("IDENTITY_CARD", this.props.setting.lang)}</legend>
              <FieldSetIdentityCard
                ref={this.ui.studentAgentIdCard}
                setting={this.props.setting}
                spinner={this.props.spinner}
                message={this.props.message}
              />
            </fieldset>
            <fieldset>
              <legend>
                {i18n("PLACE_OF_LIVING", this.props.setting.lang)}
              </legend>
              <FieldSetLocation
                ref={this.ui.studentAgentLocation}
                setting={this.props.setting}
                spinner={this.props.spinner}
                message={this.props.message}
              />
              <div className="fb-row">
                <FieldText
                  ref={this.ui.studentAgentPostalCode}
                  setting={this.props.setting}
                  option={{
                    label: "POSTAL_CODE",
                    type: "text",
                    value: "",
                    size: 20,
                    onChange: function (value) {
                      return value.length <= 10;
                    },
                  }}
                />
                <FieldText
                  ref={this.ui.studentAgentAddress}
                  setting={this.props.setting}
                  option={{
                    label: "ADDRESS",
                    type: "text",
                    value: "",
                    className: "fb-1",
                  }}
                />
              </div>
            </fieldset>
          </div>
        </div>
      </Fragment>
    );
  }
}
